import { Helmet, HelmetProvider } from 'react-helmet-async';
import PrivacyPolicyHero from '../components/PrivacyPolicy/PrivacyPolicyHero'
import PrivacyPolicyText from '../components/PrivacyPolicy/PrivacyPolicyText'




const PrivacyPolicy = () => {
  return (
    <>
      <HelmetProvider>
      <Helmet>
        <title>Privacy Policy | Brand Acumen</title>
        <meta name="description" content="Explore the services offered by Brand Acumen." />
        <meta name="description" content="Welcome to the homepage of Brand Acumen." />
        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Home | Brand Acumen" />
        <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://brandacumen.co/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Home | Brand Acumen" />
        <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
        <meta name="twitter:image" content="/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      
      <PrivacyPolicyHero />
      <PrivacyPolicyText />
      </HelmetProvider>
    </>
  );
};

export default PrivacyPolicy;